<form sc-method="item.method" sc-form="item.action" sc-form-reset="item.reset">
    <app-rendered [childview]="item.childview || childview" [paramprefix]="item.paramprefix" [info]="info" *ngFor="let it of item.content" [item]="it" [data]="data" [arr]="item.content" (deleteDataEvent)="delete($event)" (openViewEvent)="openView($event)" (openLinkEvent)="openLink($event)"></app-rendered>
    <button pButton ng-show='item.submit'>{{item.submit}}</button>
</form>
